<script>
import historyModal from "@/pages/modal/historyModal.vue";
import detailGiveMember from "@/pages/modal/detailGiveMember.vue";

// 초기세팅
function initialState() {
  return {
    basicInfo: [],
  };
}

export default {
  components: {
    historyModal,
    detailGiveMember,
  },
  data() {
    return initialState();
  },
  created() {
  },
  computed: {
  },
  filters: {
  },
  methods: {
    // 초기화
    resetWindow: function() {
      Object.assign(this.$data, initialState());
    },
    // 처음에 시작
    shown() {
      this.resetWindow();
      this.basicInfo =  this.$store.getters.getModal_lg; // store 정보 가져오기
    },
    // 사이드바 닫히면 실행되는 부분
    hidden() {
      this.resetWindow();
    },
    hide() {
      this.$bvModal.hide('modal_lg')
    },
  },
  middleware: "authentication",
};
</script>

<template>
  <b-modal
    size="lg"
    id="modal_lg"
    ref="modal_lg"
    @shown="shown"
    @hidden="hidden"
    hide-header
    hide-footer
  >
    <template>
      <historyModal v-if="basicInfo.worker=='timelineAdd' || basicInfo.worker=='timelineEdit' || basicInfo.worker=='boardAdd'"></historyModal>
      <detailGiveMember v-if="basicInfo.worker=='detailGiveMember'"></detailGiveMember>
      <div v-if="basicInfo.worker==''" class="row">
        <div class="col-xl-12">
          <div class="card mb-2">
            <div class="card-body">
              <div class="media align-items-center">
                <div class="media-body overflow-hidden">
                  <h5 class=" text-secondary text-bold">
                    <i class="uil-squint h3 text-danger"></i>
                    ...
                  </h5>
                </div>
                <a class="" href="javascript:void(0);" @click="hide">
                  <div class="btn btn-block p-0">
                    <i class="mdi mdi-close display-6 text-gray"></i>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </b-modal>
</template>
